import { useEffect, useState } from 'react';

import { useLocation } from 'react-router-dom';

import { HITS_TYPES_BY_URL } from '~/pages/DiscoverPage/const';

const useSERPNavigation = () => {
  const location = useLocation();
  const [type, setType] = useState('');

  useEffect(() => {
    const typeRegExp = new RegExp('[^/]+/?$', 'g');
    const match = location.pathname.match(typeRegExp);
    if (match && match[0]) {
      setType(match[0].replace(/\/$/, ''));
    }
  }, [location]);

  return HITS_TYPES_BY_URL[type];
};

export default useSERPNavigation;
